@switch (state) {
  @case ('loading') {
    <h1>{{ 'CALLS.EXTEND_STAY.LOADING' | translate }}</h1>
  }
  @case ('prompt') {
    <h1>{{ 'CALLS.EXTEND_STAY.PROMPT' | translate }}</h1>
    <p>{{ 'CALLS.EXTEND_STAY.PROMPT_UNTIL' | translate }} {{ leaveDate | date: 'medium' }}.</p>
    <button mat-raised-button color="primary" (click)="confirmExtend()">
      {{ 'CALLS.EXTEND_STAY.CONFIRM_BUTTON' | translate }}
    </button>
  }
  @case ('extending') {
    <h1>{{ 'CALLS.EXTEND_STAY.EXTENDING' | translate }}</h1>
  }
  @case ('extended') {
    <h1>{{ 'CALLS.EXTEND_STAY.EXTENDED_TITLE' | translate }}</h1>
    <p>{{ 'CALLS.EXTEND_STAY.EXTENDED_BODY' | translate }} {{ leaveDate | date: 'medium' }}.</p>
  }
  @case ('not-extended') {
    <h1>{{ 'CALLS.EXTEND_STAY.NOT_EXTENDED' | translate }}</h1>
  }
  @case ('error') {
    <h1>{{ 'CALLS.EXTEND_STAY.ERROR' | translate }}</h1>
  }
}
